import React from 'react';

import {PolicyStatement} from 'auth/PolicyConstants';
import {PolicyTemplateNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import getTestProps from 'test/lib/cypress/getTestProps';

import ItemTypeTable from './ItemTypeTable';

interface Props {
  policyTemplate: PolicyTemplateNode;
  isWritable: boolean;
  policyStatements: Array<PolicyStatement>;
  onUpdateStatements: (policyStatements: Array<PolicyStatement>) => void;
}

export default function PolicyStatementsEditor(props: Props): JSX.Element {
  return (
    <div {...getTestProps({component: 'PolicyStatementEditor', element: 'root'})}>
      {props.policyTemplate.itemTypeOptions.map((itemTypeOption, i) => (
        <ItemTypeTable
          key={i}
          itemTypeOption={itemTypeOption}
          policyStatements={props.policyStatements}
          onUpdateStatements={props.onUpdateStatements}
          isWritable={props.isWritable}
        />
      ))}
    </div>
  );
}
